import { Button, type ButtonProps } from '@mantine/core';
import { createLink, type LinkComponent } from '@tanstack/react-router';
import { forwardRef } from 'react';

type LinkButtonProps = Omit<ButtonProps, 'component'>;

const RouterNavLinkComponent = forwardRef<HTMLButtonElement, LinkButtonProps>((props, ref) => (
	<Button ref={ref} {...props} />
));

export const LinkButton: LinkComponent<typeof RouterNavLinkComponent> =
	createLink(RouterNavLinkComponent);
